export function addToCart(id, image, to, from, value, greeting) {
    return function(dispatch) {
        dispatch({
            type: 'GIFTCARD/ADD',
            payload: {
                id,
                image,
                to,
                from,
                value,
                greeting,
            },
        });
    };
}

export function removeFromCart(id) {
    return function(dispatch) {
        dispatch({
            type: 'GIFTCARD/REMOVE',
            payload: {
                id,
            },
        });
    };
}
